import { useState } from 'react';

import Button from 'components/shared/Buttons/Button';

import EditResultModal from './EditResultModal';

const EditResultButtons = ({ activeView, setActiveView }) => {
  const [editModal, setEditModal] = useState(null);
  const [historyMode, setHistoryMode] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      <Button
        icon="history-mono"
        disabled={isLoading}
        onClick={() => {
          setEditModal('history');
          setHistoryMode(true);
        }}
      />
      <Button
        text="Markup"
        icon="edit-2-mono"
        iconColor="white"
        color="primary"
        disabled={isLoading}
        size="small"
        onClick={() => setEditModal('edit')}
        data-qa="edit-btn"
      />
      <EditResultModal
        activeView={activeView}
        setActiveView={setActiveView}
        {...{ editModal, historyMode, setIsLoading, setEditModal, setHistoryMode, isLoading }}
      />
    </>
  );
};

export default EditResultButtons;
